let getCallbacks = () => null;
let scheduleRender = () => {};
let pullState = null;

const PULL_REFRESH_THRESHOLD = 70;
const PULL_MAX = 110;

export function configurePullRefresh(deps) {
  getCallbacks = deps.getCallbacks || getCallbacks;
  scheduleRender = deps.scheduleRender || scheduleRender;
}

export function handlePullStart(event) {
  if (event.touches.length !== 1) return;
  const view = event.target.closest?.("[data-mobile-pull-refresh]");
  if (!view) return;
  if (view.scrollTop > 0) return;
  pullState = {
    view,
    indicator: view.querySelector("[data-mobile-pull-indicator]"),
    startY: event.touches[0].clientY,
    locked: false,
  };
}

export function handlePullMove(event) {
  if (!pullState || event.touches.length !== 1) return;
  const dy = event.touches[0].clientY - pullState.startY;
  if (dy <= 0) return;
  if (!pullState.locked) {
    if (dy < 8) return;
    pullState.locked = true;
  }
  // Don't fight native scroll if it's active.
  if (pullState.view.scrollTop > 0) {
    pullState = null;
    return;
  }
  event.preventDefault();
  const offset = Math.min(PULL_MAX, dy * 0.55);
  if (pullState.indicator) {
    pullState.indicator.style.setProperty("--pull-distance", `${-40 + offset}px`);
    pullState.indicator.style.setProperty("--pull-opacity", String(Math.min(1, offset / 40)));
  }
}

export function handlePullEnd() {
  if (!pullState) return;
  const { indicator } = pullState;
  pullState = null;
  if (!indicator) return;
  const distStr = indicator.style.getPropertyValue("--pull-distance") || "-40px";
  const dist = parseFloat(distStr) + 40;
  if (dist >= PULL_REFRESH_THRESHOLD) {
    indicator.classList.add("refreshing");
    indicator.style.setProperty("--pull-distance", `${-40 + 50}px`);
    indicator.style.setProperty("--pull-opacity", "1");
    getCallbacks()?.refreshVault?.();
    setTimeout(() => {
      indicator.classList.remove("refreshing");
      indicator.style.setProperty("--pull-distance", "-40px");
      indicator.style.setProperty("--pull-opacity", "0");
      scheduleRender();
    }, 700);
  } else {
    indicator.style.setProperty("--pull-distance", "-40px");
    indicator.style.setProperty("--pull-opacity", "0");
  }
}

export function resetPullRefresh() {
  pullState = null;
}
